import {
    styled,
    FormControl,
    FormHelperText,
    TextField,
} from "@material-ui/core";
import { brand } from "../../../theme";
import { FormLabel } from "../styles/shared";

const NOTES_MAX_LENGTH = 240;

export const NotesField = styled(({
    value,
    onChange,
    ...p
}: any) => {
    const length = (value ?? "").length;
    const overWarn = length > 220;
    return (
        <FormControl margin="normal" fullWidth {...p}>
            <FormLabel>Notes · Just for you</FormLabel>
            <div className="card">
                <TextField
                    value={value ?? ""}
                    onChange={(e) =>
                        onChange((e.target.value || "").slice(0, NOTES_MAX_LENGTH))
                    }
                    placeholder="Maybe Balashi? Bitter finish. Could also be Heineken family…"
                    multiline
                    minRows={3}
                    fullWidth
                    InputProps={{ disableUnderline: true } as any}
                    inputProps={{ "data-testid": "notes", maxLength: NOTES_MAX_LENGTH } as any}
                />
                <div className={`counter${overWarn ? " counter--warn" : ""}`}>
                    {length}/{NOTES_MAX_LENGTH}
                </div>
            </div>
            <FormHelperText className="hint">
                Visible only to you. Not used for scoring.
            </FormHelperText>
        </FormControl>
    );
})(({ theme }) => ({
    marginTop: theme.spacing(3),
    "& .card": {
        background: brand.white,
        borderRadius: 12,
        padding: theme.spacing(1.5, 2),
        boxShadow: "0 1px 4px rgba(26,18,5,0.06)",
    },
    "& .counter": {
        textAlign: "right",
        fontSize: 11,
        fontWeight: 600,
        color: brand.textDis,
        marginTop: theme.spacing(0.5),
    },
    "& .counter--warn": {
        color: brand.error,
    },
    "& .hint": {
        fontSize: 12,
        fontStyle: "italic",
        color: brand.textSec,
        marginTop: theme.spacing(1),
    },
}));
